import { createClient } from '@supabase/supabase-js';
import { supabaseAuthOptions } from '@questlabs/auth-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

export function createProjectClient(sessionToken) {
  if (!url || !key || !sessionToken) return null;
  return createClient(url, key, supabaseAuthOptions(sessionToken));
}

export async function saveProject(sessionToken, project) {
  const client = createProjectClient(sessionToken);
  if (!client) return;

  const { error } = await client.from('sceneflow_projects_20250601').upsert({
    id: project.id,
    title: project.title,
    screenplay: project.screenplay,
    video_url: project.videoUrl,
    cues: project.cues,
    settings: project.settings,
    updated_at: new Date().toISOString()
  });
  if (error) throw error;
}